import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Flex, Statistic } from "antd";
import { ChartHome } from "../ChartHome/ChartHome";
import ListRestaurants from "../ListRestaurants/ListRestaurants";
import PieChartAdmin from "../PieChartAdmin/PieChartAdmin";
import { AnonymousUserService } from "deliziora-client-module/client-web/services/AnonymousUserService";
import { RestaurantService } from "deliziora-client-module/client-web/services/RestaurantService";

const CustomStatistic = ({ title, value, suffix }) => (
  <Statistic
    title={title}
    valueStyle={{ color: "orange" }}
    value={value}
    suffix={<span style={{ fontSize: "0.7rem", color: "black" }}>{suffix}</span>}
    style={statBoxStyle}
  />
);

const statBoxStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "0.5rem",
  width: "100%",
  boxShadow: "1px 2px 9px rgba(0, 0, 0, 0.245)",
  padding: "2rem",
  justifyContent: "space-between",
  borderRadius: 15,
};

const DashBoardAdmin = () => {
  const [totalUsers, setTotalUsers] = useState(0);
  const [restaurants, setRestaurants] = useState([]);
  const [totalRestaurants, setTotalRestaurants] = useState(0);
  const [allDevices, setAllDevices] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [mostVisitedDistrict, setMostVisitedDistrict] = useState("");

  const fetchData = async () => {
    try {
      const [restaurantsResponse, usersResponse] = await Promise.all([
        RestaurantService.returnAllRestaurantsSlim(),
        AnonymousUserService.returnAllUsers(),
      ]);
      const restaurantsData = restaurantsResponse.data;
      const usersData = usersResponse.data;
      setRestaurants(restaurantsData);
      setTotalRestaurants(restaurantsData.length);
      setAllUsers(usersData);
      setTotalUsers(usersData.length);
      setAllDevices(usersData.map((item) => item.device_name));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const uniqueDevices = useMemo(() => [...new Set(allDevices)], [allDevices]);

  const calculatePercentage = useCallback((value, total) => {
    return total === 0 ? "0.00" : ((value / total) * 100).toFixed(2);
  }, []);

  const renderDeviceStatistics = useCallback(() => {
    return uniqueDevices.map((itemD, index) => {
      const deviceCount = allUsers?.filter(
        (item) => item.device_name === itemD
      ).length;
      return (
        <CustomStatistic
          key={index}
          title={`Total ${itemD}`}
          value={deviceCount}
          suffix={` (${calculatePercentage(deviceCount, totalUsers)}%)`}
        />
      );
    });
  }, [allUsers, uniqueDevices, totalUsers, calculatePercentage]);

  useEffect(() => {
    // Recuperar o distrito mais visitado do Local Storage
    const storedDistrict = localStorage.getItem('mostVisitedDistrict');
    if (storedDistrict) {
      setMostVisitedDistrict(storedDistrict);
    }
  }, []);

  const isMobile = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  };

  return (
    <Flex align="center" justify="center">
      {isMobile() ? (
        <MobileDashboardAdmin
          totalUsers={totalUsers}
          totalRestaurants={totalRestaurants}
          renderDeviceStatistics={renderDeviceStatistics}
          mostVisitedDistrict={mostVisitedDistrict}
        />
      ) : (
        <DesktopDashboardAdmin
          totalUsers={totalUsers}
          totalRestaurants={totalRestaurants}
          renderDeviceStatistics={renderDeviceStatistics}
          mostVisitedDistrict={mostVisitedDistrict}
        />
      )}
    </Flex>
  );
};

const MobileDashboardAdmin = ({
  totalUsers,
  totalRestaurants,
  renderDeviceStatistics,
  mostVisitedDistrict,
}) => (
  <Flex
    vertical
    style={{ width: "100%", padding: "1rem", overflow: "auto", gap: "1rem" }}
    align="center"
    justify="center"
  >
    <ChartHome />
    <CustomStatistic title="Total de Usuários" value={totalUsers} suffix="" />
    <CustomStatistic
      title="Total de Restaurantes"
      value={totalRestaurants}
      suffix=""
    />
    {renderDeviceStatistics()}
    <CustomStatistic title="Distrito mais visitado" value={mostVisitedDistrict} suffix="" />
    <PieChartAdmin />
    <ListRestaurants />
  </Flex>
);

const DesktopDashboardAdmin = ({
  totalUsers,
  totalRestaurants,
  renderDeviceStatistics,
  mostVisitedDistrict,
}) => (
  <Flex justify="space-evenly" style={{
    width: "100%",
    overflow: "hidden",
  }}>
    <Flex
      gap={30}
      vertical
      justify="center"
      style={{ width: "60%", padding: "2rem" }}
    >
      <Flex vertical>
        <ChartHome />
      </Flex>
      <Flex gap="middle" horizontal justify="space-between" style={{
        width: "100%",
        padding: "1rem",
        overflow: "auto",
      }}>
        <CustomStatistic
          title="Total de Usuários"
          value={totalUsers}
          suffix=""
        />
        <CustomStatistic
          title="Total de Restaurantes"
          value={totalRestaurants}
          suffix=""
        />
        {renderDeviceStatistics()}
      </Flex>
      <Flex justify={"center"} vertical align={"center"} gap={10} style={{
        width: "100%",
        overflow: "auto",
      }}>
        <CustomStatistic
          title="Distrito mais visitado"
          value={mostVisitedDistrict}
          suffix=""
        />
        <PieChartAdmin />
      </Flex>
    </Flex>
    <Flex align="flex-start" justify="flex-start"
      style={{ width: "40%", maxHeight: "83vh", overflow: "auto", marginTop: "2rem" }}
      vertical
      gap={60}
    >
      <ListRestaurants />
    </Flex>
  </Flex>

);

export default DashBoardAdmin;
